"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Placeholder = void 0;
const react_1 = __importDefault(require("react"));
const Placeholder = (props) => {
    return react_1.default.createElement("div", { style: props.style, className: "placeholder" }, props.children);
};
exports.Placeholder = Placeholder;
exports.default = exports.Placeholder;
